import React from 'react';

import './style.scss';

const ParagraphTextWithIcon = ({ entity }) => {
  const icon = entity.getIn(['field_icon', 0, 'entity', 'field_icon', 0, 'value'], '');
  const subtitle = entity.getIn(['field_subtitle', 0, 'value'], '');
  const title = entity.getIn(['field_title', 0, 'value'], '');

  return (
    <div className="ParagraphTextWithIcon">

      <div className="row">
        <div className="col-4 col-md-12 col-lg-4">
          <div className="ParagraphTextWithIcon__icon">
            <i className={`icon icon-${icon} icon-variant-1`} />
          </div>
        </div>

        <div className="col-8 col-md-12 col-lg-8">
          <div className="ParagraphTextWithIcon__textWrap">
            <div className="ParagraphTextWithIcon__title">
              <h3>{title}</h3>
            </div>

            <div className="ParagraphTextWithIcon__subtitle label">
              <h3>{subtitle}</h3>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ParagraphTextWithIcon;
